<template>
  <b-modal :id="modalId" no-close-on-backdrop no-close-on-esc>
    <div
      class="mx-2"
      :class="type === 'wide' ? 'modal-alert-wide' : 'modal-alert'"
      :style="{ '--btn-width': buttonWidth }"
    >
      <b-alert
        v-if="error"
        :show="error && error.length ? true : false"
        variant="danger"
      >
        <div v-if="Array.isArray(error)">
          <div
            class="d-flex flex-column my-1"
            v-for="(error_text, index) in error"
            :key="index"
          >
            {{ error_text }}
          </div>
        </div>
        <div v-else>
          <div v-html="error || '&nbsp;'"></div>
        </div>
      </b-alert>
      <div class="modal-alert-wide__content" v-if="type === 'wide'">
        <div class="modal-alert-wide__head">
          <img :src="iconSrc" alt="popup icon" />
          <div>{{ title }}</div>
        </div>

        <div class="modal-alert-wide__desc">{{ description }}</div>
        
        <!-- Content slot for additional content between description and buttons -->
        <div v-if="$slots.content" class="modal-alert-wide__content-slot">
          <slot name="content"></slot>
        </div>
        
        <div
          class="modal-alert-wide__btns"
        >
          <slot name="buttons" ref="buttonsSlot"></slot>
        </div>
      </div>
      <div class="text-center" v-else>
        <img :src="iconSrc" alt="popup icon" class="mb-4" />
        <div class="title-lg mb-1">{{ title }}</div>
        <div class="desc-sm mb-4 mx-3">{{ description }}</div>
        <div
          class="text-center row d-flex justify-content-center align-items-center gap-2"
        >
          <slot name="buttons" ref="buttonsSlot"></slot>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: ["modalId", "icon", "title", "description", "error", "type", "widthButton"],
  computed: {
    iconSrc() {
      return require(`@/assets/images/icons/${this.icon}.svg`);
    },
    getSlotChildrenCount() {
      return this.$slots.buttons ? this.$slots.buttons.length : 0;
    },
    buttonWidth() {
      if (this.widthButton) {
        return this.widthButton;
      }
      return this.getSlotChildrenCount === 1 ? "30%" : "25%";
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-alert {
  padding: 3rem 0rem;
}

.modal-alert-wide {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 32px;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 8px;
    border-bottom: 1px solid var(--color-64);

    div {
      color: var(--color-155);
      font-size: 18px;
      font-weight: 700;
      line-height: 32px;
    }
  }

  &__desc {
    color: var(--color-155);
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.25px;
  }

  &__content-slot {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  &__btns {
    display: flex;
    align-items: center;
    justify-content: end;
    gap: 18px;
  }
}
</style>
